import React, { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Table, Badge as BsBadge, Button, Nav } from 'react-bootstrap';
import { useQuery, useQueryClient } from 'react-query';
import Pagination from 'react-js-pagination';
import * as moment from 'moment';
import { QUANLY_HOSONGHIENCUUSINH_API, QUAN_LY_TUYEN_SINH_API, DOTTUYENSINH_API } from '@app/utils/apiUrl';
import { Get } from '@app/utils/httpProvider';
import { createUrlWithParam } from '@app/utils/helper';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { objectShowNumber, objectTrangThaiHoSoNCS, trangThaiHoSoNCSValue, objectTrangThaiYeuCau, objectGiaiDoanDaoTao, objectLoaiYeuCau } from '@app/utils/define';
import ThongTinNghienCuuSinhModal from '../hoSoNghienCuuSinh/ThongTinNghienCuuSinhModal';
import DuyetThayDoi from './DuyetThayDoi';
import CongNhanTienSiModal from './CongNhanTienSiModal';

const QuanLyHoSoNCS = () => {
    const history = useHistory();
    const location = useLocation();
    const queryClient = useQueryClient();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    const [showDetail, setShowDetail] = useState(false);
    const [showCongNhanTienSi, setShowCongNhanTienSi] = useState(false);
    const [activeTab, setActiveTab] = useState('danhSach');
    const [selectedRow, setSelectedRow] = useState(null);
    const tableRef = useRef(null);
    const [search, setSearch] = useState('');
    const [searchMaNCS, setSearchMaNCS] = useState('');
    const [dotTuyenSinhId, setDotTuyenSinhId] = useState('');
    const [thoiHanDaoTao, setThoiHanDaoTao] = useState('');
    const [trangThaiFilter, setTrangThaiFilter] = useState('');
    const [trangThaiYeuCauFilter, setTrangThaiYeuCauFilter] = useState('');
    const [giaiDoanFilter, setGiaiDoanFilter] = useState('');
    const [loaiYeuCauFilter, setLoaiYeuCauFilter] = useState('');

    const { data: listDotTuyenSinhData } = useQuery(
        ['listDotTuyenSinhNCS'],
        () => Get(DOTTUYENSINH_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000, LoaiTuyenSinh: 3 }),
        { keepPreviousData: true }
    );
    const listDotTuyenSinh = listDotTuyenSinhData?.data?.$values || listDotTuyenSinhData?.data || [];

    useEffect(() => {
        const paramUrl = new URLSearchParams(location.search.substring(1));
        if (paramUrl.get('page') != null) {
            setPage(parseInt(paramUrl.get('page'), 10));
        }
        if (paramUrl.get('size') != null) {
            setPageSize(parseInt(paramUrl.get('size'), 10));
        }
        if (paramUrl.get('search') != null) {
            setSearch(paramUrl.get('search'));
        }
        if (paramUrl.get('mancs') != null) {
            setSearchMaNCS(paramUrl.get('mancs'));
        }
        if (paramUrl.get('dot') != null) {
            setDotTuyenSinhId(paramUrl.get('dot'));
        }
        if (paramUrl.get('thoihan') != null) {
            setThoiHanDaoTao(paramUrl.get('thoihan'));
        }
        if (paramUrl.get('trangthai') != null) {
            setTrangThaiFilter(paramUrl.get('trangthai'));
        }
        if (paramUrl.get('giaidoan') != null) {
            setGiaiDoanFilter(paramUrl.get('giaidoan'));
        }
        if (paramUrl.get('loaiyeucau') != null) {
            setLoaiYeuCauFilter(paramUrl.get('loaiyeucau'));
        }
    }, []);

    const replaceHistory = (Page, Size, Search, SearchMaNCS, Dot, ThoiHan, TrangThai, GiaiDoan, LoaiYeuCau) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.QUANLY_HOSO_NCS_PATH, {
                page: Page,
                size: Size,
                search: Search,
                mancs: SearchMaNCS,
                dot: Dot,
                thoihan: ThoiHan,
                trangthai: TrangThai,
                giaidoan: GiaiDoan,
                loaiyeucau: LoaiYeuCau
            })
        );
    };

    const { isLoading, data, refetch } = useQuery(
        ['quanLyHoSoNCS', search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, giaiDoanFilter, loaiYeuCauFilter, page, pageSize],
        () => {
            const model = {
                Keyword: search || '',
                MaNCS: searchMaNCS || '',
                PageIndex: page,
                PageSize: pageSize
            };
            if (dotTuyenSinhId) model.DotTuyenSinhId = dotTuyenSinhId;
            if (thoiHanDaoTao) model.ThoiHanDaoTao = thoiHanDaoTao;
            if (trangThaiFilter) model.TrangThai = trangThaiFilter;
            if (giaiDoanFilter) model.GiaiDoanDaoTao = giaiDoanFilter;

            replaceHistory(page, pageSize, search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, giaiDoanFilter, loaiYeuCauFilter);
            return Get(QUANLY_HOSONGHIENCUUSINH_API.GET_PAGING, null, model);
        },
        {
            keepPreviousData: true
        }
    );

    useEffect(() => {
        if (activeTab === 'danhSach') {
            refetch();
        }
    }, [activeTab]);

    useEffect(() => {
        refetch();
    }, [pageSize, page, search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, giaiDoanFilter, loaiYeuCauFilter]);

    const items = data?.data?.$values ? data.data.$values : data?.data || [];
    const totalRecords = data?.totalRecords || 0;

    useEffect(() => {
        if (items && items.length > 0) {
            setSelectedRow(prev => {
                if (prev) {
                    const fresh = items.find(item => (item.id || item.Id) === (prev.id || prev.Id));
                    return fresh || items[0];
                }
                return items[0];
            });
        } else {
            setSelectedRow(null);
        }
    }, [items]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, giaiDoanFilter, loaiYeuCauFilter);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(Number(e.target.value));
        replaceHistory(page, Number(e.target.value), search, searchMaNCS, dotTuyenSinhId, thoiHanDaoTao, trangThaiFilter, giaiDoanFilter, loaiYeuCauFilter);
    };

    const handleViewDetail = () => {
        if (selectedRow) setShowDetail(true);
    };

    const handleCongNhanTienSi = () => {
        if (selectedRow) setShowCongNhanTienSi(true);
    };

    const handleDoubleClick = (item) => {
        const rowData = item || selectedRow;
        if (!rowData) return;
        const id = rowData.id || rowData.Id;
        history.push(URI_INTERNAL.QUANLY_GIAIDOAN_DAOTAO_NCS_PATH.replace(':id', id));
    };

    const handleSelectRow = (row) => {
        if (selectedRow && (selectedRow.id || selectedRow.Id) === (row.id || row.Id)) {
            setSelectedRow(null);
        } else {
            setSelectedRow(row);
        }
    };

    return (
        <div className="container-fluid">
            <Card className="card-sticky-layout">
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <Nav variant="pills" className="flex-row">
                            <Nav.Item>
                                <Nav.Link 
                                    active={activeTab === 'danhSach'} 
                                    onClick={() => setActiveTab('danhSach')}
                                    className="font-weight-bold"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Danh sách hồ sơ NCS
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link 
                                    active={activeTab === 'duyetThayDoi'} 
                                    onClick={() => setActiveTab('duyetThayDoi')}
                                    className="font-weight-bold"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Duyệt yêu cầu thay đổi
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                </Card.Header>
                <Card.Body className="d-flex flex-column">
                    <div className="d-flex mb-3 flex-wrap">
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Tìm kiếm:</span>
                            <Form.Control 
                                type="text" 
                                placeholder="Nhập tên hoặc CCCD..." 
                                value={search} 
                                onChange={(e) => { setSearch(e.target.value); setPage(1); }} 
                                style={{ width: '175px' }} 
                            />
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Mã NCS:</span>
                            <Form.Control 
                                type="text" 
                                placeholder="Nhập mã NCS..." 
                                value={searchMaNCS} 
                                onChange={(e) => { setSearchMaNCS(e.target.value); setPage(1); }} 
                                style={{ width: '140px' }} 
                            />
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Đợt tuyển sinh:</span>
                            <Form.Control as="select" value={dotTuyenSinhId} onChange={(e) => { setDotTuyenSinhId(e.target.value); setPage(1); }} style={{ width: '150px' }}>
                                <option value="">Tất cả đợt</option>
                                {listDotTuyenSinh.map((dot) => (
                                    <option key={dot.id || dot.Id} value={dot.id || dot.Id}>{dot.tenDot || dot.TenDot}</option>
                                ))}
                            </Form.Control>
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Thời hạn:</span>
                            <Form.Control as="select" value={thoiHanDaoTao} onChange={(e) => { setThoiHanDaoTao(e.target.value); setPage(1); }} style={{ width: '100px' }}>
                                <option value="">Tất cả</option>
                                <option value="0">3 năm</option>
                                <option value="1">4 năm</option>
                            </Form.Control>
                        </div>
                        <div className="d-flex align-items-center mr-3 mb-2">
                            <span className="font-weight-bold mr-2">Trạng thái:</span>
                            {activeTab === 'duyetThayDoi' ? (
                                <Form.Control as="select" value={trangThaiYeuCauFilter} onChange={(e) => { setTrangThaiYeuCauFilter(e.target.value); setPage(1); }} style={{ width: '150px' }}>
                                    <option value="">Tất cả</option>
                                    {objectTrangThaiYeuCau.map((status) => (
                                        <option key={status.value} value={status.value}>{status.label}</option>
                                    ))}
                                </Form.Control>
                            ) : (
                                <Form.Control as="select" value={trangThaiFilter} onChange={(e) => { setTrangThaiFilter(e.target.value); setPage(1); }} style={{ width: '150px' }}>
                                    <option value="">Tất cả</option>
                                    {objectTrangThaiHoSoNCS.map((status) => (
                                        <option key={status.value} value={status.value}>{status.label}</option>
                                    ))}
                                </Form.Control>
                            )}
                        </div>
                        {activeTab === 'duyetThayDoi' && (
                            <div className="d-flex align-items-center mr-3 mb-2">
                                <span className="font-weight-bold mr-2">Loại yêu cầu:</span>
                                <Form.Control as="select" value={loaiYeuCauFilter} onChange={(e) => { setLoaiYeuCauFilter(e.target.value); setPage(1); }} style={{ width: '150px' }}>
                                    <option value="">Tất cả</option>
                                    {objectLoaiYeuCau.map((loai) => (
                                        <option key={loai.value} value={loai.value}>{loai.label}</option>
                                    ))}
                                </Form.Control>
                            </div>
                        )}
                        {activeTab !== 'duyetThayDoi' && (
                            <div className="d-flex align-items-center mr-3 mb-2">
                                <span className="font-weight-bold mr-2">Giai đoạn:</span>
                                <Form.Control as="select" value={giaiDoanFilter} onChange={(e) => { setGiaiDoanFilter(e.target.value); setPage(1); }} style={{ width: '150px' }}>
                                    <option value="">Tất cả</option>
                                    {objectGiaiDoanDaoTao.map((gd) => (
                                        <option key={gd.value} value={gd.value}>{gd.label}</option>
                                    ))}
                                </Form.Control>
                            </div>
                        )}
                    </div>

                    {activeTab === 'danhSach' && (
                        <Card className="card-sticky-layout border-0 shadow-none flex-grow-1">
                            <Card.Body className="d-flex flex-column p-0">
                                <div className="table-responsive flex-grow-1" ref={tableRef}>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th className="text-center" style={{ width: '50px' }}>STT</th>
                                                <th>Mã NCS</th>
                                                <th>Số CCCD</th>
                                                <th>Họ và tên</th>
                                                <th>Ngành</th>
                                                <th>Chuyên ngành</th>
                                                <th>Đợt tuyển sinh</th>
                                                <th>Thời hạn</th>
                                                <th>Đào tạo đến</th>
                                                <th className="text-center">Trạng thái</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                <tr>
                                                    <td colSpan="10" className="text-center">Đang tải dữ liệu...</td>
                                                </tr>
                                            ) : items.length === 0 ? (
                                                <tr>
                                                    <td colSpan="10" className="text-center">Không có dữ liệu</td>
                                                </tr>
                                            ) : (
                                                items.map((item, index) => {
                                                    const hsTS = item.hoSoTuyenSinhInfo || {};
                                                    
                                                    let thoiHanStr = '';
                                                    if (item.thoiHanDaoTao === 0 || String(item.thoiHanDaoTao) === '0' || (typeof item.thoiHanDaoTao === 'string' && item.thoiHanDaoTao.toLowerCase() === 'banam')) {
                                                        thoiHanStr = '3 năm';
                                                    } else if (item.thoiHanDaoTao === 1 || String(item.thoiHanDaoTao) === '1' || (typeof item.thoiHanDaoTao === 'string' && item.thoiHanDaoTao.toLowerCase() === 'bonnam')) {
                                                        thoiHanStr = '4 năm';
                                                    }

                                                    const trangThaiVal = item.trangThai ?? item.TrangThai ?? trangThaiHoSoNCSValue.choDaoTao;
                                                    const trangThaiObj = objectTrangThaiHoSoNCS.find(x => x.value === trangThaiVal);
                                                    const trangThaiLabel = trangThaiObj ? trangThaiObj.label : 'Chờ đào tạo';
                                                    
                                                    let variant = 'warning';
                                                    if (trangThaiVal === trangThaiHoSoNCSValue.choDaoTao) variant = 'warning';
                                                    else if (trangThaiVal === trangThaiHoSoNCSValue.dangDaoTao || trangThaiVal === trangThaiHoSoNCSValue.congNhanTienSi) variant = 'success';
                                                    else if (trangThaiVal === trangThaiHoSoNCSValue.tamDungDaoTao) variant = 'info';
                                                    else if (trangThaiVal === trangThaiHoSoNCSValue.dangGiaHan || trangThaiVal === trangThaiHoSoNCSValue.quaHan) variant = 'danger';
                                                    else if (trangThaiVal === trangThaiHoSoNCSValue.boDaoTao) variant = 'primary';

                                                    return (
                                                        <tr 
                                                            key={item.id || item.Id || index} 
                                                            onClick={() => setSelectedRow(item)}
                                                            onDoubleClick={() => handleDoubleClick(item)} 
                                                            className={selectedRow && (selectedRow.id || selectedRow.Id) === (item.id || item.Id) ? 'table-primary' : ''}
                                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                                        >
                                                            <td className="text-center">{(page - 1) * pageSize + index + 1}</td>
                                                            <td>{item.maNCS || hsTS.soHoSo}</td>
                                                            <td>{item.soCCCD}</td>
                                                            <td>{item.hoTen}</td>
                                                            <td>{item.tenNganh}</td>
                                                            <td>{item.tenChuyenNganh || 'Không có'}</td>
                                                            <td>{item.tenDotTuyenSinh}</td>
                                                            <td>{thoiHanStr}</td>
                                                            <td>
                                                                {item.denNgay ? moment(item.denNgay).format('DD/MM/YYYY') : ''}
                                                                {item.soThangGiaHan ? (
                                                                    <div className="keep-color-orange" style={{ fontSize: '0.85em', color: '#ff9800', marginTop: '4px', whiteSpace: 'nowrap' }}>
                                                                        <i className="fas fa-clock mr-1"></i>Gia hạn {item.soThangGiaHan} tháng
                                                                    </div>
                                                                ) : null}
                                                            </td>
                                                            <td className="text-center">
                                                                <BsBadge variant={variant}>{trangThaiLabel}</BsBadge>
                                                                {(item.maxGiaiDoan || item.MaxGiaiDoan) ? (
                                                                    <div className="mt-1 d-flex align-items-center justify-content-center" title={objectGiaiDoanDaoTao.find(s => s.value == ((item.maxGiaiDoan || item.MaxGiaiDoan) - 1))?.label || "Giai đoạn đã làm"}>
                                                                        <span className="mr-1" style={{ fontSize: '0.85em', fontWeight: '500', color: '#666' }}>Giai đoạn</span>
                                                                        <span className="badge-stage">
                                                                            {item.maxGiaiDoan || item.MaxGiaiDoan}
                                                                        </span>
                                                                    </div>
                                                                ) : null}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-3 p-2">
                                    <div>
                                        <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '100px' }}>
                                            {objectShowNumber.map((opt) => (
                                                <option key={opt.value} value={opt.value}>{opt.text}</option>
                                            ))}
                                        </Form.Control>
                                    </div>
                                    <div>
                                        {totalRecords > 0 && (
                                            <Pagination
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                innerClass="pagination pagination-sm no-margin"
                                                activePage={page}
                                                itemsCountPerPage={pageSize}
                                                totalItemsCount={totalRecords}
                                                pageRangeDisplayed={5}
                                                onChange={changePage}
                                            />
                                        )}
                                    </div>
                                </div>
                            </Card.Body>
                            {!isLoading && (
                                <Card.Footer className="bg-white card-footer-sticky">
                                    <div className="d-flex justify-content-end pr-4">
                                        <Button 
                                            variant="info" 
                                            size="sm" 
                                            onClick={handleViewDetail} 
                                            className="mr-2"
                                            disabled={!selectedRow}
                                        >
                                            <i className="fas fa-eye mr-1"></i> Xem chi tiết
                                        </Button>
                                        <Button 
                                            variant="primary" 
                                            size="sm" 
                                            onClick={() => handleDoubleClick(selectedRow)}
                                            disabled={!selectedRow}
                                            className="mr-2"
                                        >
                                            <i className="fas fa-tasks mr-1"></i> Giai đoạn đào tạo
                                        </Button>
                                        <Button 
                                            variant="success" 
                                            size="sm" 
                                            onClick={handleCongNhanTienSi}
                                            disabled={!selectedRow}
                                        >
                                            <i className="fas fa-graduation-cap mr-1"></i> Công nhận tiến sĩ
                                        </Button>
                                    </div>
                                </Card.Footer>
                            )}
                        </Card>
                    )}
                    {activeTab === 'duyetThayDoi' && (
                        <DuyetThayDoi 
                            search={search} 
                            searchMaNCS={searchMaNCS} 
                            dotTuyenSinhId={dotTuyenSinhId} 
                            thoiHanDaoTao={thoiHanDaoTao} 
                            trangThaiFilter={trangThaiYeuCauFilter} 
                            loaiYeuCauFilter={loaiYeuCauFilter}
                        />
                    )}
                </Card.Body>
            </Card>

            {showDetail && selectedRow && (
                <ThongTinNghienCuuSinhModal
                    show={showDetail}
                    handleClose={() => {
                        setShowDetail(false);
                        refetch();
                        queryClient.invalidateQueries(['quanLyHoSoNCS']);
                    }}
                    hoSoId={selectedRow.id || selectedRow.Id}
                />
            )}

            {showCongNhanTienSi && selectedRow && (
                <CongNhanTienSiModal
                    dataEdit={selectedRow}
                    setViewMode={(mode) => {
                        if (mode === 'list') {
                            setShowCongNhanTienSi(false);
                            refetch();
                            queryClient.invalidateQueries(['quanLyHoSoNCS']);
                            queryClient.invalidateQueries(['congNhanTienSiUser']);
                        }
                    }}
                />
            )}
        </div>
    );
};

export default QuanLyHoSoNCS;

